import { render, staticRenderFns } from "./CenterViewPreview_Ap.vue?vue&type=template&id=4f06bae2&scoped=true"
import script from "./CenterViewPreview_Ap.vue?vue&type=script&lang=js"
export * from "./CenterViewPreview_Ap.vue?vue&type=script&lang=js"
import style0 from "./CenterViewPreview_Ap.vue?vue&type=style&index=0&id=4f06bae2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f06bae2",
  null
  
)

export default component.exports